import usePermissionsStore from '../stores/permissionsStore';

/**
 * Check if the current user holds a specific permission.
 * Usage: const canWrite = useHasPermission('crm', 'write');
 */
export function useHasPermission(module: string, action: string): boolean {
  return usePermissionsStore((state) => state.hasPermission(module, action));
}

/**
 * Returns the full permissions map.
 * Useful for rendering permission-gated menus.
 */
export function usePermissions() {
  return usePermissionsStore((state) => state.permissions);
}
